import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CollectionReward')
export class CollectionReward {

  @JsonProperty('reward_id', Number)
  rewardId: number = 0;

  @JsonProperty('currency_type', Number)
  currencyType: number = 0;

  @JsonProperty('currency_quantity', Number)
  currencyQuantity: number = 0;

  @JsonProperty('currency_ticket_cost', Number)
  currencyTicketCost: number = 0;
}
